var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1800.67 1800.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#00dd9a;}.cls-3{fill:#172683;}.cls-4{fill:#999;opacity:0.58;mix-blend-mode:multiply;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    className: "cls-2",
    d: "M1774.15,1702a70.27,70.27,0,0,1-68.07,72.4c-1.45,0-2.89,0-4.34,0h-289c-40,0-78.59-21.51-78.6-78.6s0-1096.21,0-1141.28S1312.41,467,1246.56,467s-1106.87,0-1146.33,0A74.73,74.73,0,0,1,25,392.79v-1c0-44.64,0-239,0-278.83s31.68-90.36,87.85-87.85,1539.92,0,1581.72,0,81.06,33.88,81.1,88S1774.15,1702,1774.15,1702Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    className: "cls-3",
    d: "M1099.39,796.32c0-56.31-28.58-91.51-91.5-91.5s-857.71,0-896.33,0-84.33,12.1-84.33,84.33V1696a75.41,75.41,0,0,0,79.65,79.64h906.5c51.82,0,76.8-30.1,82.81-82.82S1099.39,796.32,1099.39,796.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.4,1122.67H424.51a0,0,0,0,1,0,0v230.6a0,0,0,0,1,0,0H142.4A115.3,115.3,0,0,1,27.1,1238v0a115.3,115.3,0,0,1,115.3-115.3Z",
    transform: "translate(451.61 2475.93) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.69,1239a67.16,67.16,0,1,0,67.16-67.15A67.16,67.16,0,0,0,232.69,1239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.94,1291.29a67.15,67.15,0,1,0,94.3-94.59,67.15,67.15,0,0,1-94.3,94.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 299.85,
    cy: 1238.98,
    r: 32.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon_logo.df0691e7729170f0b40bfb7589e8e517.svg";
export { ForwardRef as ReactComponent };